<template>
<div>
        <v-card class="pt-1 mt-4">
            <v-toolbar flat dense>
                <v-toolbar-title class="text-subtitle-1">NOTAS Y DOCUMENTOS</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn small color="primary" @click="documentsDialog = true">
                    Crear
                </v-btn>
            </v-toolbar>

            <v-divider></v-divider>
            <v-data-table :headers="columnsDocumentos" :items="documentos" item-key="name" class="elevation-1"
                :custom-filter="customFilter" :loading="loading" loading-text="Cargando..." dense>
                <template v-slot:item.url="{ item }">
                    <v-icon small class="mr-2" @click="verDocumento(item)">
                        mdi-eye
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>


        <!-- ADD DOCUMENTS -->
        <v-dialog v-model="documentsDialog" max-width="750px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Creación de Documento / Nota</span>
                </v-card-title>

                <div style="padding: 30px">
                    <DocumentosNotasModal :accionGuardar="accionGuardar" :poliza="polizaId" />
                </div>

<v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="documentsDialog = false">
                        Cerrar
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="(accionGuardar = true), (documentsDialog = false)">
                        Guardar
                    </v-btn>
                </v-card-actions>
</v-card>
</v-dialog>


<!-- MODAL VER DOCUMENTOS -->
<v-dialog v-model="dialogDetalleDocumentos" max-width="750px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Detalle de Documento / Nota</span>
                </v-card-title>

                <template>
                    <v-container style="padding: 30px">
                        <v-row>
                            <v-col cols="6">
                                <v-text-field label="Nombre" v-model="detallesDocumento.nombre" readonly></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox label="¿Enviar por correo electrónico?" readonly></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <v-select label="Tipo" :items="tipoItems" v-model="detallesDocumento.tipo" required
                                    readonly></v-select>
                            </v-col>
                            <v-col cols="6" v-if="detallesDocumento.tipo == 'Documento'">
                                <v-select label="Tipo de Doocumento*" :items="tipoDocumentoItems"
                                    v-model="detallesDocumento.tipoDocumento" required readonly></v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="Descripción" v-model="detallesDocumento.descripcion" required
                                    readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="4" v-if="detallesDocumento.url">
                                <template>
                                    <v-file-input v-model="documentos" color="primary" label="Adjuntos*">
                                        <template v-slot:selection="{ index }">
                                            <v-chip v-if="index < 1" color="primary" dark label small
                                                @click="detallesDocumento.url">
                                                {{ detallesDocumento.nombre }}
                                            </v-chip>

                                            <span v-else-if="index === 2"
                                                class="text-overline grey--text text--darken-3 mx-2">
                                                +{{ documentos.length - 2 }} Archivos(s)
                                            </span>
                                        </template>
                                    </v-file-input>
                                </template>
                            </v-col>
                            <v-col cols="2" v-if="detallesDocumento.url">
                                <v-btn text :href="detallesDocumento.url" small color="primary" class="mt-4">
                                    <v-icon>mdi-download</v-icon>
                                    Descargar
                                </v-btn>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="Creado por" v-model="detallesDocumento.creadoPor"
                                    readonly></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="Fecha de Creación" v-mask="'##/##/####'"
                                    v-model="detallesDocumento.fecha" readonly></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </template>
            </v-card>
        </v-dialog>
</div>
</template>

<script>
import DocumentosNotasModal from '../../../../components/DocumentosNotasModal.vue';
export default {
    name: 'DocumentosCard',
    components: {
        DocumentosNotasModal
    },
    data() {
        return {
            documentsDialog: false,
            accionGuardar: false,
            detallesDocumento: {},
            dialogDetalleDocumentos: false,
            tipoItems: ["Nota", "Documento"],
            tipoDocumentoItems: [
                "Acta constitutiva",
                "Comprobante de Domicilio",
                "Comprobante Médico",
                "Contrato firmado del Agente",
                "Cotización",
                "Cédula del Agente",
                "Identificación",
                "Poder Notarial",
                "Póliza",
                "RC de Agente",
                "Tarjeta de Circulación",
                "Otro",
            ],
            columnsDocumentos: [
                {
                    text: "Nombre",
                    align: "start",
                    sortable: false,
                    value: "nombre",
                },
                { text: "Tipo", value: "tipo" },
                { text: "Descripción", value: "descripcion" },
                { text: "Creado por", value: "creadoPor" },
                { text: "Fecha", value: "fecha" },
                { text: "Ver", value: "url" },
            ],
        }
    },
    props: {
        documentos: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        customFilter: {
            type: Function,
            default: null
        },
        polizaId: {
            type: Number,
            required: null
        }
    },
    methods: {
        verDocumento(documento) {
            this.dialogDetalleDocumentos = true;
            this.detallesDocumento = documento;
        },
    }

}

</script>